import { BaseStudioEdge } from './BaseStudioEdge';

export const studioEdgeTypes = {
  default: BaseStudioEdge,
};
